/**
 * Create a small i18next shim for just the strings
 * the modal needs.
 *
 * WARNING! This only includes `en`!
 */

import geocornStrings from '@apps-common/geocorn-sdk/locales/en.json';
import {createInstance} from 'i18next';

import modalStrings from './locales/en.json';

const i18n = createInstance();

i18n.init({
  resources: {
    en: {
      translation: {
        ...modalStrings,
        ...geocornStrings,
      },
    },
  },
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
